module.exports = __webpack_public_path__ + "static/media/arrow.58a4396e.svg";